import { render, staticRenderFns } from "./ModalSmall.vue?vue&type=template&id=7da26853&scoped=true&"
import script from "./ModalSmall.vue?vue&type=script&lang=js&"
export * from "./ModalSmall.vue?vue&type=script&lang=js&"
import style0 from "./ModalSmall.vue?vue&type=style&index=0&id=7da26853&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da26853",
  null
  
)

export default component.exports